import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';


Vue.use(Vuex);

const store = new Vuex.Store({

  state: {
    User: JSON.parse(localStorage.getItem('user')),
    Modules: JSON.parse(localStorage.getItem('modules')),
    CashBoxName: JSON.parse(localStorage.getItem('cashBoxName')),
    Permissions: JSON.parse(localStorage.getItem('permissions')),
    UseTwoStepsTwoStepVerification: JSON.parse(localStorage.getItem('useTwoStepsTwoStepVerification')),
  },

  mutations: {
    // -- Funcion que setea el usuario que se logueo en el "state"
    setLogin(state, user) {
      state.User = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    isPasswordChanged(state, result) {
      state.User.ChangePassword = result;
      localStorage.setItem('user', JSON.stringify(state.User));
    },
    setModules(state, modules) {
      state.Modules = modules;
      localStorage.setItem('modules', JSON.stringify(state.Modules));
    },
    updateAccountVerificationEnabled(state, accountVerificationEnabled) {
      state.User.TwoStepVerification = accountVerificationEnabled;
    },
    updateIsMailVerify(state, iMailVerify) {
      state.User.IsMailVerify = iMailVerify;
      localStorage.setItem('user', JSON.stringify(state.User));
    },
    updatePhoneVerify(state, isPhoneVerify) {
      state.User.IsPhoneVerify = isPhoneVerify;
      localStorage.setItem('user', JSON.stringify(state.User));
    },
    setUsePaymentPin(state, usePaymentPin) {
      state.User.UsePaymentPin = usePaymentPin;
      localStorage.setItem('user', JSON.stringify(state.User));
    },
    setCashBoxName(state, cashBoxName) {
      state.CashBoxName = cashBoxName;
      localStorage.setItem('cashBoxName', JSON.stringify(cashBoxName));
    },
    setPermissions(state, permissions) {
      state.Permissions = permissions;
      localStorage.setItem('permissions', JSON.stringify(state.Permissions));
    },
    setUseTwoStepsTwoStepVerification(state, useTwoStepsTwoStepVerification) {
      state.UseTwoStepsTwoStepVerification = useTwoStepsTwoStepVerification;
      localStorage.setItem('useTwoStepsTwoStepVerification', JSON.stringify(state.UseTwoStepsTwoStepVerification));
    },
    setNewDevice(state, value) {
      state.User.NewDevice = value;
    },
    setTermsAndConditionsAccepted(state, value) {
      state.User.TermsAndConditionsAccepted = value;
    },
    setMustAcceptPEP(state, value) {
      state.User.MustAcceptPEP = value;
    }
  },

  actions: {
    login(context, user) {
      context.commit('setLogin', user);
      context.commit('setModules', null);
      context.commit('setPermissions', null);
      context.commit('setUseTwoStepsTwoStepVerification', false);
    },
    logout(context) {
      context.commit('setLogin', null);
      context.commit('setModules', null);
      context.commit('setCashBoxName', '');
      context.commit('setPermissions', null);
    },
    initPermissions(context, permissions) {
      context.commit('setPermissions', permissions);
    },
    passwordChanged(context, result) {
      context.commit('isPasswordChanged', result);
    },
    initModules(context, modules) {
      context.commit('setModules', modules);
    },
    updateAccountVerification(context, accountVerificationEnabled) {
      context.commit('updateAccountVerificationEnabled', accountVerificationEnabled);
    },
    AccountWithMailVerify(context, isMailVerify) {
      context.commit('updateIsMailVerify', isMailVerify);
    },
    AccountSetUsePaymentPin(context, usePaymentPin) {
      context.commit('setUsePaymentPin', usePaymentPin);
    },
    PhoneVerify(context, isPhoneVerify) {
      context.commit('updatePhoneVerify', isPhoneVerify);
    },
    initCashBoxName(context, cashBoxName) {
      context.commit('setCashBoxName', cashBoxName);
    },
    UpdateUseTwoStepsTwoStepVerification(context, useTwoStepsTwoStepVerification) {
      context.commit('setUseTwoStepsTwoStepVerification', useTwoStepsTwoStepVerification);
    }
  },

  getters: {
    accountID: state => {
      return state.User.AccountID;
    },
    accountTypeID: state => {
      return state.User.AccountTypeID;
    },
    profileID: state => {
      return state.User.ProfileID;
    },
    isCommerce: state => {
      return state.User.AccountTypeID == 3;
    },
    isAssociatedCommerce: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ACCTPCOMEASOC');

        if (paramList.length > 0) {
          return state.User.AccountTypeID == parseInt(paramList[0].Value);
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    isLogged: state => {
      return state.User != null
    },
    userToken: state => {
      if (state.User != undefined && state.User != null) {
        return state.User.Token;
      }
      else {
        return null;
      }
    },
    LastEntryDate: state => {
      if (state.User != undefined && state.User != null) {
        return state.User.LastEntryDate;
      }
      else {
        return null;
      }
    },
    userName: state => {
      if (state.User != undefined && state.User != null) {
        return state.User.Name;
      }
      else {
        return '';
      }
    },
    CUIT_CUIL: state => {
      if (state.User != undefined && state.User != null) {
        return state.User.CUIT_CUIL;
      }
      else {
        return '';
      }
    },
    userChangePassword: state => {
      if (state.User != undefined && state.User != null) {
        return state.User.ChangePassword;
      }
      else {
        return '';
      }
    },
    useTwoStepsTwoStepVerification: state => {
      return state.UseTwoStepsTwoStepVerification;
    },
    isCashier: state => {
      if (state.User.ProfileID == 5) {
        return true;
      }
      else {
        return false;
      }
    },
    cashBoxName: state => {
      return state.CashBoxName;
    },
    HasModules: state => {
      return state.Modules != null && state.Modules.length > 0;
    },
    ModuleList: state => {
      return state.Modules;
    },
    ModuleActionList: state => {
      var arrAction = [];
      if (state.Modules) {
        state.Modules.forEach(m => {
          if (m.Action) {
            arrAction.push(m.Action);
          }
        });
      }

      return arrAction;
    },
    HasPermissions: state => {
      return state.Permissions != null && state.Permissions.length > 0;
    },
    PermissionList: state => {
      return state.Permissions;
    },
    EdenorArticleID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'IDARTICULOEDENOR');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    SaldoReservaMastercard: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'SALDORESERVAMASTERCARD');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    TipoDireccionTitular: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TIPODIRECCIONTITULAR');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    TipoDireccionEntrega: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TIPODIRECCIONENTREGA');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MastercardPendienteDeVerificacion: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ESTADOSOLICITUDTAJETAPENDIENTEVERIFICACION');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MastercardAprobado: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ESTADOSOLICITUDTAJETAAPROBADA');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MastercardRechazado: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ESTADOSOLICITUDTAJETARECHAZADA');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MastercardEntregado: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ESTADOSOLICITUDTAJETAENTREGADA');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MastercardImpresa: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ESTADOSOLICITUDTAJETAIMPRESA');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MastercardEnCamino: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ESTADOSOLICITUDTAJETAENCAMINO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MastercardSolicitudAlta: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ESTADOSOLICITUDTAJETASOLDEALTA');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    EmailAddress: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'HDCEMAILADRESS');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    EmailSubject: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'HDCEMAILSUBJECT');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MessageBody: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'HDCMESSAGEBODY');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    UrlWhatsapp: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'HDCWHATSAPPURL');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    PhoneNumber: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'HDCPHONENUMBER');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDTipoRequisitoAdjunto: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TPRQARC');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDTipoRequisitoIMG: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TPRQIMG');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDTipoRequisitoTXT: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TPRQTXT');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDTipoRequisitoEscaneoDNI: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TPRQESC');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDTipoRequisitoDireccion: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TPRQDIR');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDTipoRequisitoIMGCod: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TPRQIMGCOD');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },

    IDEstadoTajetaMsrdOperativa: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'EstadoTajetaMsrdOperativa');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDEstadoTajetaMsrdCongelada: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'EstadoTajetaMsrdCongelada');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDEstadoTajetaMsrdBaja: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'EstadoTajetaMsrdBaja');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    ULTMOVIMIENTOSOBTENERTARJETAS: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ULTMOVIMIENTOSOBTENERTARJETAS');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    OPCIONMENUREIMPRESIONTARJETAMASTERCARD: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'OPCREIMPRESION');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    OPCIONMENURETIRODEDINEROTARJETAMASTERCARD: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'OPCRETIRODEDINERO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MAX_LENGTH_NEIGHBORHOOD: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'LENBARRIO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MAX_LENGTH_STREET: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'LENCALLE');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MAX_LENGTH_STREET_NUMBER: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'LENALTURA');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MAX_LENGTH_FLOOR: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'LENPISO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MAX_LENGTH_DEPARTMENT: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'LENDEPARTAMENTO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MAX_LENGTH_POSTAL_CODE: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'LENCODIGOPOSTAL');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    identityWasVerificated: state => {
      return state.User.IdentityWasVerificated;
    },
    DoubleFactorSecurityList: state => {
      var arrList = [];
      if (state.User.DoubleFactorSecurityList) {
        state.User.DoubleFactorSecurityList.forEach(m => {
          if (m.Enable) {

            arrList.push(m.Url);

          }
        });
      }

      return arrList;
    },
    TwoStepVerification: state => {
      return state != null && state.User != null && state.User.TwoStepVerification;
    },
    DOUBLEFACTORSECENABLE: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'DOUBLEFACTORSECENABLE');

        if (paramList.length > 0) {
          return paramList[0].Value.toLowerCase() == 'true';
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    CordobaParkingArticleID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'IDART_PARK_CBA');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    JuninParkingArticleID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'IDART_PARK_JUNIN');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    OlavarriaParkingArticleID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'IDART_PARK_SPK');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IsMailVerify: state => {
      return state.User.IsMailVerify;
    },
    UsePaymentPin: state => {
      return state.User.UsePaymentPin;
    },
    ShouldPerformTwoStepVerification: state => {
      return state.User.ShouldPerformTwoStepVerification;
    },
    NewDevice: state => {
      return state.User.NewDevice;
    },
    TermsAndConditionsAccepted: state => {
      return state.User.TermsAndConditionsAccepted;
    },
    MustAcceptPEP: state => {
      return state.User.MustAcceptPEP;
    },
    PagoProveedorTypeReceiptID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'EGRPAGPROV');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    SMSCodeMethodID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'METVERTELEFONO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MailCodeMethodID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'METVEREMAIL');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IsPhoneVerify: state => {
      return state.User.IsPhoneVerify;
    },
    MinimumTransferAmount: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'VALDOBFACTRANSMONMIN');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    MsgNotAfipConstancy: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'DEF_MSG_VERIFICATION_NO_AFIP_CONSTANCY');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    IDTipoRequisitoCBU: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TPRQCBU');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    HabilitarDevolucionParcialQR: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'BOOLQRDEVPAR');

        if (paramList.length > 0) {
          return paramList[0].Value === 'true';
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    FintouchReceipTypeEntryOperationId: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'OPFIING');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    SystemaWebAppId: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'SYS_WEB_APP_RS');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    AccountTypeSupervisorId: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ACCTPSUPERVISOR');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    isAccountTypeSupervisor(state, getters) {
      if (
        getters.accountTypeID == getters.AccountTypeSupervisorId
      ) {
        return true;
      } else {
        return false;
      }
    },
    UrlTawkTo: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'URL_TAWK_TO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    SiteUrl: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'SITEURL');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'IDTIPMETACUMDATOS');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    CASH_OUT_ATTEMPTS_METHODTYPE_ID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'IDTIPMETACUMDINERO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    PIN_SECURITY_METHOD_ID: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'IDTIPMETSECPIN');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    ID_CREDIT_PAYMENT_METHOD: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'MEDIO_PAGO_CREDITO');

        if (paramList.length > 0) {
          return parseInt(paramList[0].Value);
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    ID_DEBIT_PAYMENT_METHOD: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'MEDIO_PAGO_DEBITO');

        if (paramList.length > 0) {
          return parseInt(paramList[0].Value);
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    ID_QR_MONEY_IN_ACCOUNT_PAYMENT_METHOD: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'MEDIO_PAGO_QR_DINERO_EN_CUENTA');

        if (paramList.length > 0) {
          return parseInt(paramList[0].Value);
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    HabilitarAgregarDispositivo: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'ADD_DEVICE_ENABLED_FINTOUCH');

        if (paramList.length > 0) {
          return paramList[0].Value === 'true';
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    FINTOUCH_MAX_OP_ADELANTO: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'FINTOUCH_MAX_OP_ADELANTO');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    CODE_EXPIRATION_TIME_ASOCIATE_DEVICE_VALIDATION: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TIEXVERVINCDISP');

        if (paramList.length > 0) {
          return paramList[0].Value;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    SHOW_TOTAL_OPERATED_CASHIER: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'SHOW_TOTAL_OPERATED_CASHIER');

        if (paramList.length > 0) {
          return paramList[0].Value === 'true';
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    TYC_DEBIN_SPOT: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TYC_DEBIN_SPOT');

        if (paramList.length > 0) {
          return parseInt(paramList[0].Value);
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    TYC_DEBIN_RECURRENTE: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TYC_DEBIN_RECURRENTE');

        if (paramList.length > 0) {
          return parseInt(paramList[0].Value);
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
    TYC_DEBIN_PROGRAMADO: state => {
      if (state.User.Parameters != undefined && state.User.Parameters != null) {
        var paramList = state.User.Parameters.filter(p => p.Key == 'TYC_DEBIN_PROGRAMADO');

        if (paramList.length > 0) {
          return parseInt(paramList[0].Value);
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
    },
  },
});

export default store;